import { BasicFolderForAdvancedSearch, FolderClassificationDetailsBinder, FolderClassificationDetailsChildren } from './chemise';

export class Classeur {
  public id: number;
  public description?: string;
}

export class BasicBinderForAdvancedSearch extends Classeur {
  accesRestreint?: boolean;
  affine?: string;
  ancienNbr?: string;
  archived?: boolean;

  localisation?: string;
  partage?: boolean;
  remarques?: string;
  service?: BasicServiceForBinder;
  chemises?: BasicFolderForAdvancedSearch[];
}
export class BasicServiceForBinder {
  codeService?: string;
  description?: string;
  id?: number;
  limiterNatures?: boolean;
  parentId?: number;
}

export class FolderClassificationDetails {
  id: number;
  description: string;
  localisation: string;
  remarques: string;
  accesRestreint: boolean;
  affine: string;
  ancienNbr: string;
  partage: boolean;
  archived: boolean;
  chemises: FolderClassificationDetailsBinder[];
  children?: FolderClassificationDetailsChildren[]; // for mapping purposes only

  label?: string;
  labelOrder?: string;
  data?: number;
  type?: string;
  actif?: boolean;
  key?: number;
  expanded?: boolean;
}
